import { render } from "./MenuContentItemTableCellInput.vue?vue&type=template&id=1b7b6f08"
import script from "./MenuContentItemTableCellInput.vue?vue&type=script&lang=js"
export * from "./MenuContentItemTableCellInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__